import { Action } from 'redux';
import * as shallowEqual from 'shallowequal';

import { isEnterSpaceAction } from '../../actions/spaces/EnterSpaceAction';
import { isChangeRecommendationTypeAction } from '../../actions/spaces/RecommendationTypeAction';
import { RecommendationType } from '../../spaces/RecommendationSpace/RecommendationTypeDropdown';

export function recommendationTypeReducer(
  previousState: RecommendationType = 'all',
  action: Action = null
): RecommendationType {
  if (isChangeRecommendationTypeAction(action)) {
    if (!previousState || !shallowEqual(previousState, action.recommendationType)) {
      return action.recommendationType;
    }
  } else if (isEnterSpaceAction(action)) {
    // reset recommendation type filter to 'all' when entering recommendations space
    if (action.spaceType === 'recommendations') {
      let newState: RecommendationType = 'all';
      if (!previousState || !shallowEqual(newState, previousState)) {
        return newState;
      }
    }

  }
  return previousState;
}
